import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'app-one-col-area',
  templateUrl: './one-col-area.component.html',
  styleUrls: ['./one-col-area.component.css']
})
export class OneColAreaComponent implements OnInit {

  @Input() oneColArea_params: any = {}
  constructor() { }

  ngOnInit(): void {
  }

}
